import React from "react";
import "./Setting_Center.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import Tab_list from "../Common/Common_Component/Tab_list/Tab_list";
import Change_Nickname_modal from "../Common/Common_Component/Common_Modal/Change_Nickname_modal/Change_Nickname_modal";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function Setting_Center() {
    const [modalShow, setModalShow] = React.useState(false);
  const tabListData = [
    {
      type: "link",
      name: "Login Password",
      image: "/assets/images/icons/lock_box.png",
      link: "/change-password",
    },
    {
      type: "link",
      name: "Bind Mailbox",
      image: "/assets/images/icons/mail_box.png",
      link: "/bind-mailbox",
    },
  ];
  return (
    <>
      <section className="Setting_Center">
        <Common_white_header headingText={"Setting Center"} />

        <div className="container">
          {/* PROFILE CARD */}
          <div className="profile_card">
            <div className="profile_holder">
              <div className="img_holder">
                <img
                  src="https://i.pravatar.cc/100"
                  alt="profile"
                  className="profile_img"
                />
              </div>

              <div className="profile_action">
                Change Profile
                <span className="arrow">›</span>
              </div>
            </div>

            <div className="profile_info">
              <div className="nickname_row">
                <span className="label">Nickname</span>
                <span className="value" onClick={() => setModalShow(true)}>MEMBERNN6QJIT <FontAwesomeIcon icon={faChevronRight} /></span>
              </div>

              <div className="uid_row">
                <span className="label">UID</span>
                <span className="value">15473870 <FontAwesomeIcon icon={faChevronRight} /></span>
              </div>
            </div>
          </div>

          <Tab_list listItems={tabListData} />
        </div>
      </section>
       <Change_Nickname_modal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

export default Setting_Center;
